<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row>
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="n in 2" :key="`line1_${n}`" cols="3">
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="n in 4" :key="`line1_${n}`" cols="3">
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
    </v-sheet>
    <div v-show="!showSkeleton">
      <v-row dense class="text-h4">
        Configurações de Facilidades
      </v-row>
      <v-divider class="ma-4" />
      <v-row class="ml-2">
        <div class="text-h5">Facilidades do PABX</div>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="3">
          <v-text-field outlined dense v-model="form.capturaGrupo" :rules="rules" label="Captura de Grupo" />
        </v-col>
        <v-col cols="3">
          <v-text-field outlined dense v-model="form.capturaRamal" :rules="rules" label="Captura de Ramal" />
        </v-col>
      </v-row>
      <v-row class="ml-2">
        <div class="text-h5">Facilidades do CallCenter</div>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="3">
          <v-text-field outlined dense v-model="form.logarAgente" :rules="rules" label="Login do Agente" />
        </v-col>
        <v-col cols="3">
          <v-text-field outlined dense v-model="form.deslogarAgente" :rules="rules" label="Logoff do Agente" />
        </v-col>
        <v-col cols="3">
          <v-text-field outlined dense v-model="form.pausarAgente" :rules="rules" label="Pausar Agente" />
        </v-col>
        <v-col cols="3">
          <v-text-field outlined dense v-model="form.despausarAgente" :rules="rules" label="Despausar Agente" />
        </v-col>
      </v-row>

      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import FixedButtons from '@/componentes/FixedButtons'
import Snackbar from '@/componentes/Snackbar'
import { registerVuexModule } from '@/utils/vuexUtils'

import facilidadesStore from '../_store'
import facilidadesHttpServices from '../_services/facilidadesHttpServices'

export default {
  name: 'Facilidades',
  components: { FixedButtons, Snackbar },
  data: () => ({
    snackbar: false,
    showSkeleton: false,
    text: '',
    rules: [value => /^[\dXs#?*+\-[\]]{1,20}.{0,1}$/g.test(value) || /^.$/.test(value) || !value || 'Regex inválida'],
    form: {
      capturaGrupo: '',
      capturaRamal: '',
      logarAgente: '',
      deslogarAgente: '',
      pausarAgente: '',
      despausarAgente: '',
    },
    pararLoader: {
      parar: false,
    },
  }),

  computed: {
    ...mapGetters('facilidadesHomeModulePABXStore', ['getFacilidades']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'facilidadesHomeModulePABXStore', facilidadesStore)
    await this.listarFacilidades()
    this.getFacilidades.forEach(facilidade => {
      this.form[`${facilidade.description}`] = facilidade.regex[0].regexVisual
    })

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('facilidadesHomeModulePABXStore', ['listarFacilidades']),
    async salvar() {
      this.pararLoader.parar = false
      try {
        await facilidadesHttpServices.postFacilidades(this.form)
        this.$router.back()
      } catch (err) {
        console.log(err)
        this.text = err.response.data
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },

    cancelar() {
      this.$router.back()
    },
  },
}
</script>
